export const CARD_LABEL = 'Estimated Cost';

export const D2D_QUALIFICATION_EVENT = 'Life D2D policy estimate';

export const BANNER_HORIZON_URN =
  'urn:pg:service:actuary:product:ace0e7fa-eefd-462a-a3c8-d7718bbcf174';

export const BRIGHTHOUSE_SIMPLY_SELECT_URN =
  'urn:pg:service:actuary:product:eac5a6e2-6e93-45d8-b917-7a82fb55137b';

export const FORESTERS_YOUR_TERM_URN =
  'urn:pg:service:actuary:product:ff0282fe-7af3-44ec-8a7a-2a6bcf0c1cdd';

export const COREBRIDGE_GUARANTEED_ISSUE_URN =
  'urn:pg:service:actuary:product:096b526d-94c4-438a-87f7-bb06b442334c';

export const MUTUAL_OMAHA_GUARANTEED_WHOLE_LIFE_URN =
  'urn:pg:service:actuary:product:3af2411e-3029-4ee5-84f9-533644c93628';

export const MOBILE_INSURER_LOGOS = [
  'lincoln-financial-black-logo.svg',
  'corebridge-black-logo.svg',
  'pacific-life-black-logo.svg',
  'transamerica-black-logo.svg',
];
export const DESKTOP_INSURER_LOGOS = ['principal-black-logo.svg', 'protective-black-logo.svg'];

export const INSURERS_LABEL = 'Coverage available from top providers';

export const VIEW_ALL_BUTTON = 'View all';

export const COMPARE_QUOTES_SUCCESS = 'Continue to get quotes';

export const INSURER_LOGO_MODAL_ANALYTICS_PROPERTIES = {
  modalId: 'insurer-logo-modal',
  source: 'bau-estimates-card',
};
